import { useLocalization } from "../../composables/useLocalization.mjs";
import transformDateString from "../../../helpers/transformDateString.mjs";
import {
  required,
  email,
  minLength,
  maxLength,
  minValue,
  maxValue,
  numeric,
  helpers
} from "@vuelidate/validators";
import { after, before, oneOf, regex } from "./customValidators.mjs";
const { createLocalizedMessage } = useLocalization();
function createLocalizedValidator(validator, ruleName, customMessage) {
  const messageFunction = createLocalizedMessage(ruleName, customMessage);
  return messageFunction ? helpers.withMessage(messageFunction, validator) : validator;
}
const getValidationRules = (field) => {
  const rules = {};
  if (field.validations?.required) {
    const customMessage = typeof field.validations.required === "object" ? field.validations.required.error_message : void 0;
    rules.required = createLocalizedValidator(
      required,
      "required",
      customMessage
    );
  }
  if (field.validations?.email) {
    const customMessage = typeof field.validations.email === "object" ? field.validations.email.error_message : void 0;
    rules.email = createLocalizedValidator(email, "email", customMessage);
  }
  if (field.validations?.min) {
    const val = typeof field.validations.min === "object" ? field.validations.min.value : field.validations.min;
    const customMessage = typeof field.validations.min === "object" ? field.validations.min.error_message : void 0;
    if (typeof val === "number") {
      rules.minLength = createLocalizedValidator(
        minLength(val),
        "min",
        customMessage
      );
    }
  }
  if (field.validations?.max) {
    const val = typeof field.validations.max === "object" ? field.validations.max.value : field.validations.max;
    const customMessage = typeof field.validations.max === "object" ? field.validations.max.error_message : void 0;
    if (typeof val === "number") {
      rules.maxLength = createLocalizedValidator(
        maxLength(val),
        "max",
        customMessage
      );
    }
  }
  if (field.validations?.min_value) {
    const val = typeof field.validations.min_value === "object" ? field.validations.min_value.value : field.validations.min_value;
    const customMessage = typeof field.validations.min_value === "object" ? field.validations.min_value.error_message : void 0;
    if (typeof val === "number") {
      rules.minValue = createLocalizedValidator(
        minValue(val),
        "min_value",
        customMessage
      );
    }
  }
  if (field.validations?.max_value) {
    const val = typeof field.validations.max_value === "object" ? field.validations.max_value.value : field.validations.max_value;
    const customMessage = typeof field.validations.max_value === "object" ? field.validations.max_value.error_message : void 0;
    if (typeof val === "number") {
      rules.maxValue = createLocalizedValidator(
        maxValue(val),
        "max_value",
        customMessage
      );
    }
  }
  if (field.validations?.regex) {
    const val = typeof field.validations.regex === "object" ? field.validations.regex.value : field.validations.regex;
    const customMessage = typeof field.validations.regex === "object" ? field.validations.regex.error_message : void 0;
    if (val instanceof RegExp || typeof val === "string") {
      const messageFunction = createLocalizedMessage("regex", customMessage);
      rules.regex = messageFunction ? helpers.withMessage(messageFunction, regex(val)) : regex(val, customMessage);
    }
  }
  if (field.validations?.numeric) {
    const customMessage = typeof field.validations.numeric === "object" ? field.validations.numeric.error_message : void 0;
    rules.numeric = createLocalizedValidator(numeric, "numeric", customMessage);
  }
  if (field.validations?.one_of) {
    const val = typeof field.validations.one_of === "object" ? field.validations.one_of.value : field.validations.one_of;
    const customMessage = typeof field.validations.one_of === "object" ? field.validations.one_of.error_message : void 0;
    if (Array.isArray(val)) {
      const messageFunction = createLocalizedMessage("oneOf", customMessage);
      rules.oneOf = messageFunction ? helpers.withMessage(messageFunction, oneOf(val)) : oneOf(val, customMessage);
    }
  }
  if (field.validations?.after) {
    const val = typeof field.validations.after === "object" ? field.validations.after.value : field.validations.after;
    const customMessage = typeof field.validations.after === "object" ? field.validations.after.error_message : void 0;
    if (typeof val === "string") {
      const transformedDate = transformDateString(val);
      const messageFunction = createLocalizedMessage("after", customMessage);
      rules.after = messageFunction ? helpers.withMessage(messageFunction, after(transformedDate)) : after(transformedDate, customMessage);
    }
  }
  if (field.validations?.before) {
    const val = typeof field.validations.before === "object" ? field.validations.before.value : field.validations.before;
    const customMessage = typeof field.validations.before === "object" ? field.validations.before.error_message : void 0;
    if (typeof val === "string") {
      const transformedDate = transformDateString(val);
      const messageFunction = createLocalizedMessage("before", customMessage);
      rules.before = messageFunction ? helpers.withMessage(messageFunction, before(transformedDate)) : before(transformedDate, customMessage);
    }
  }
  return rules;
};
export default getValidationRules;
